import { useTimeSlotHeight } from '../../../../../contexts/TimeSlotHeightContext';

export interface InteractionCardProps {
    firstCardTime: number;
    quarterTimeStamp: number;
    startTime: number;
    endTime: number;
}

export const InteractionCard: React.FC<InteractionCardProps> = (props) => {
    const { firstCardTime, quarterTimeStamp, startTime, endTime } = props;
    const { staticStyle, dynamicStyle } = computeStyles(firstCardTime, quarterTimeStamp, startTime, endTime);

    return (
        <div>
            <div
                className={staticStyle}
                style={dynamicStyle}
            >
            </div>
        </div>
    );
}

type InteractionCardStyles = {
    staticStyle: string;
    dynamicStyle: React.CSSProperties;
};

export function computeStyles(firstCardTime: number, quarterTimeStamp: number, startTime: number, endTime: number): InteractionCardStyles {
    const { timeSlotHeight } = useTimeSlotHeight();
    //静的スタイル
    const opacityStyle = 'opacity-70 pointer-events-none bg-white';
    const staticStyle = `${opacityStyle} px-3 absolute z-[50] w-full h-full overflow-y-hidden text-xs text-black text-[0.925rem] leading-6`;

    //動的スタイル
    const cardBoxNum = (endTime - startTime) / quarterTimeStamp;
    const height = cardBoxNum * timeSlotHeight - 10;
    const positionTop = (startTime - firstCardTime) / quarterTimeStamp * timeSlotHeight;
    const dynamicStyle = {
        top: `${positionTop}px`,
        height: `${height}px`
    };

    return { staticStyle, dynamicStyle };
}